import React, {FC, ReactNode} from "react";
import clsx from "clsx";
import FfairPaper from "view/components/FfairPaper";
import Alert from "view/components/Alert";
import useStyles from "./styles";

interface Props {
  action?: ReactNode;
  className?: string;
}

const EmptyAlert: FC<Props> = ({action, className, children}) => {
  const classes = useStyles();

  return (
    <FfairPaper className={clsx(classes.root, className)}>
      <Alert severity="info" action={action}>
        {children}
      </Alert>
    </FfairPaper>
  );
};

export default EmptyAlert;
